import api from "../apiConfig";

const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/remotely-extra?${params}`);
  },
  getAllMyExtra(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/my-remotely-extra?${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/remotely-extra/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/remotely-extra`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/remotely-extra/${id}`, data);
  },
  reject(id) {
    return api.put(`/api/v1/remotely-extra/reject/${id}`);
  },
};
